import { config } from "../config/config";
import { setCookie } from "../modules/helper";

export enum Language {
  ARABIC = "AR",
  ENGLISH = "EN"
}

export function languageMiddleWare(req, res, next) {

  let lang=(req.originalUrl.startsWith('/ar/')||req.originalUrl.endsWith('/ar'))?'AR':'EN'

  function validLanguageCookie(): boolean {
    return req.cookies[config.cookie.language] && (req.cookies[config.cookie.language] !== Language.ENGLISH || req.cookies[config.cookie.language] !== Language.ARABIC)
  }
    setCookie(req, res, config.cookie.language, lang) 
    next()
}